import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconLogo } from '@resy/ui-kitchen';
import HamburgerButton from '../../../../svg/dynamic/hamburger.svg';
import './MobileMenu.scss';

const MobileMenu = (
  {
    drawerClickHandler,
    resyLogoLink,
    show,
  }
) => (
  <div className="MobileMenu">
    <div className="container">
      <div className="MobileMenu__navigation">
        <Button
          href={resyLogoLink.url}
          className="MobileMenu__resy-logo"
          variant="no-style"
          aria-label="Resy Logo. Click to go home."
        >
          <IconLogo height="30" width="68" />
        </Button>
        <div className="MobileMenu__toggle-button">
          <Button
            variant="no-style"
            type="button"
            className="MobileMenu__toggle-button--button toggle"
            onClick={drawerClickHandler}
            aria-label="Mobile menu"
            aria-haspopup="true"
            aria-expanded={show}
          >
            <HamburgerButton className="MobileMenu__hamburger" />
          </Button>
        </div>
      </div>
    </div>
  </div>
);

MobileMenu.propTypes = {
  drawerClickHandler: PropTypes.func.isRequired,
  resyLogoLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  show: PropTypes.bool.isRequired,
};

export default MobileMenu;
